(function () {
  'use strict';

  if (window.BiossProductPageConjugationPillsStartedV64) return;
  window.BiossProductPageConjugationPillsStartedV64 = true;

  var CACHE_PREFIX = 'bioss:product-page-conj:v64-cy55-handles:';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var pending = {};

  var LABELS = [
    'PerCP-Cy5.5', 'APC-Cy5.5', 'APC-Cy7', 'PE-Cy5.5', 'PE-Cy7', 'PE-Cy5',
    'BF350', 'BF405', 'BF488', 'BF555', 'BF594', 'BF647', 'BF680', 'BF750',
    'Biotin', 'FITC', 'TRITC', 'RBITC', 'PerCP', 'HRP', 'APC', 'Cy5.5', 'Cy3', 'Cy5', 'Cy7', 'PE', 'AP'
  ];

  function normalize(text) {
    return String(text || '').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
  }

  function normalizeSku(text) {
    return normalize(text).replace(/[^A-Za-z0-9.-]/g, '').toLowerCase();
  }

  function normalizeProductHandle(handle) {
    return String(handle || '').replace(/((?:^|-)(?:(?:percp|apc|pe)-)?cy5)\.5$/i, '$1-5');
  }

  function normalizeUrl(url) {
    if (!url) return '';
    var str = String(url).replace(/\\\//g, '/').replace(/^https?:\/\/[^/]+/i, '').split('#')[0].trim();
    var match = str.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? '/products/' + normalizeProductHandle(match[1]) : '';
  }

  function handleFromUrl(url) {
    var match = String(url || '').replace(/\\\//g, '/').match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? normalizeProductHandle(match[1]) : '';
  }

  function canonicalLabel(label) {
    var upper = normalize(label).replace(/_/g, '-').replace(/\s+/g, '-').toUpperCase();
    var map = {
      'UNCONJUGATED': 'Unconjugated',
      'NONE': 'Unconjugated',
      'NO-CONJUGATION': 'Unconjugated',
      'BF350': 'BF350',
      'BF405': 'BF405',
      'BF488': 'BF488',
      'BF555': 'BF555',
      'BF594': 'BF594',
      'BF647': 'BF647',
      'BF680': 'BF680',
      'BF750': 'BF750',
      'FITC': 'FITC',
      'PE': 'PE',
      'APC': 'APC',
      'CY3': 'Cy3',
      'CY5': 'Cy5',
      'CY5.5': 'Cy5.5',
      'CY5-5': 'Cy5.5',
      'CY7': 'Cy7',
      'PE-CY5': 'PE-Cy5',
      'PE-CY5.5': 'PE-Cy5.5',
      'PE-CY5-5': 'PE-Cy5.5',
      'PE-CY7': 'PE-Cy7',
      'APC-CY5.5': 'APC-Cy5.5',
      'APC-CY5-5': 'APC-Cy5.5',
      'APC-CY7': 'APC-Cy7',
      'PERCP': 'PerCP',
      'PERCP-CY5.5': 'PerCP-Cy5.5',
      'PERCP-CY5-5': 'PerCP-Cy5.5',
      'BIOTIN': 'Biotin',
      'HRP': 'HRP',
      'AP': 'AP',
      'TRITC': 'TRITC',
      'RBITC': 'RBITC'
    };
    return map[upper] || '';
  }

  function labelHandleSuffix(label) {
    var value = canonicalLabel(label) || normalize(label);
    return String(value || '').toLowerCase().replace(/\s+/g, '-');
  }

  function shopifyHandleSuffix(label) {
    return String(canonicalLabel(label) || label || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function pillClass(label) {
    return 'conj-' + String(label || '')
      .toLowerCase()
      .replace(/\./g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function stripKnownSuffix(value) {
    var text = normalizeSku(value);
    for (var i = 0; i < LABELS.length; i += 1) {
      var suffix = '-' + labelHandleSuffix(LABELS[i]);
      var shopifySuffix = '-' + shopifyHandleSuffix(LABELS[i]);
      if (suffix && text.slice(-suffix.length) === suffix) return text.slice(0, -suffix.length);
      if (shopifySuffix && text.slice(-shopifySuffix.length) === shopifySuffix) return text.slice(0, -shopifySuffix.length);
    }
    return text;
  }

  function isAntibodyBaseSku(value) {
    return /^bs[mfp]?-[0-9]{2,8}[a-z]?$/i.test(normalizeSku(value));
  }

  function candidateHandlesForLabel(baseSku, label) {
    var base = normalizeSku(baseSku);
    var suffix = labelHandleSuffix(label);
    var shopifySuffix = shopifyHandleSuffix(label);
    var handles = [];

    if (base && shopifySuffix) handles.push(base + '-' + shopifySuffix);
    if (base && suffix && suffix !== shopifySuffix) handles.push(base + '-' + suffix);
    if (base && suffix && suffix.indexOf('.') !== -1) handles.push(base + '-' + suffix.replace(/\./g, '-'));

    var seen = {};
    return handles.filter(function (handle) {
      if (!handle || seen[handle]) return false;
      seen[handle] = true;
      return true;
    });
  }

  function labelFromText(text, baseSku) {
    var combined = normalize(text);
    var upper = combined.replace(/_/g, '-').replace(/\s+/g, '-').toUpperCase();
    upper = upper.replace(/((?:^|-)(?:(?:PERCP|APC|PE)-)?CY5)-5(?=$|[-_/])/g, '$1.5');

    if (baseSku && normalizeSku(combined) === normalizeSku(baseSku)) return 'Unconjugated';
    if (/\b(unconjugated|no conjugation|none)\b/i.test(combined)) return 'Unconjugated';

    for (var i = 0; i < LABELS.length; i += 1) {
      var label = LABELS[i];
      var escaped = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var pattern = new RegExp('(^|[-_\\s/])' + escaped.replace(/\\\./g, '[.]') + '($|[-_\\s/])', 'i');
      if (pattern.test(upper)) return canonicalLabel(label);
    }

    return '';
  }

  function readCache(key) {
    if (!key || !window.sessionStorage) return null;
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (!cached || !cached.time || !('data' in cached)) return null;
      if (Date.now() - cached.time > CACHE_TTL_MS) return null;
      return cached.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, data) {
    if (!key || !window.sessionStorage) return;
    try {
      window.sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), data: data }));
    } catch (e) {}
  }

  function fetchJson(url, group) {
    if (!url || !window.fetch) return Promise.resolve(null);

    var key = CACHE_PREFIX + group + ':' + url;
    var cached = readCache(key);
    if (cached !== null) return Promise.resolve(cached || null);

    if (pending[url]) return pending[url];

    pending[url] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('request failed');
      return response.json();
    }).then(function (payload) {
      writeCache(key, payload || false);
      delete pending[url];
      return payload || null;
    }).catch(function () {
      writeCache(key, false);
      delete pending[url];
      return null;
    });

    return pending[url];
  }

  function addEntry(entries, entry) {
    if (!entry) return;

    var url = normalizeUrl(entry.url || entry.href || entry.product_url || entry.productUrl || entry.link || '');
    var handle = normalize(entry.handle || '');
    if (!url && handle) url = '/products/' + handle;
    if (!url) return;

    entries.push({
      title: normalize(entry.title || entry.name || entry.label || ''),
      url: url,
      handle: handleFromUrl(url) || handle,
      sku: normalizeSku(entry.sku || entry.product_sku || entry.productSku || '')
    });
  }

  function addSkuEntry(entries, sku) {
    var cleanSku = normalizeSku(sku);
    if (!cleanSku) return;
    addEntry(entries, { title: cleanSku, url: '/products/' + cleanSku, handle: cleanSku, sku: cleanSku });
  }

  function parseRaw(raw, entries) {
    var text = String(raw || '').replace(/\\\//g, '/');
    if (!text) return;

    try {
      traverse(JSON.parse(text), entries);
    } catch (e) {}

    var anchorPattern = /<a\b[^>]*href=["']([^"']+)["'][^>]*>(.*?)<\/a>/ig;
    var anchorMatch;
    while ((anchorMatch = anchorPattern.exec(text))) {
      addEntry(entries, { url: anchorMatch[1], title: anchorMatch[2].replace(/<[^>]+>/g, ' ') });
    }

    var urlPattern = /(https?:\/\/[^"'<>\s]+\/products\/[^"'<>\s,;]+|\/products\/[^"'<>\s,;]+)/ig;
    var urlMatch;
    while ((urlMatch = urlPattern.exec(text))) addEntry(entries, { url: urlMatch[1] });

    var suffixPattern = '(?:percp-cy5\\.5|percp-cy5-5|apc-cy5\\.5|apc-cy5-5|apc-cy7|pe-cy5\\.5|pe-cy5-5|pe-cy7|pe-cy5|bf350|bf405|bf488|bf555|bf594|bf647|bf680|bf750|biotin|fitc|tritc|rbitc|percp|hrp|apc|cy3|cy5\\.5|cy5-5|cy5|cy7|pe|ap)';
    var skuPattern = new RegExp('\\b(bs[mfp]?-[0-9]{2,8}[a-z]?(?:-' + suffixPattern + '))\\b', 'ig');
    var skuMatch;
    while ((skuMatch = skuPattern.exec(text))) addSkuEntry(entries, skuMatch[1]);
  }

  function traverse(value, entries) {
    if (!value) return;
    if (Array.isArray(value)) {
      value.forEach(function (item) { traverse(item, entries); });
      return;
    }
    if (typeof value === 'object') {
      addEntry(entries, value);
      Object.keys(value).forEach(function (key) {
        if (typeof value[key] === 'object') traverse(value[key], entries);
        if (typeof value[key] === 'string') parseRaw(value[key], entries);
      });
      return;
    }
    if (typeof value === 'string') parseRaw(value, entries);
  }

  function entriesFromPayload(payload) {
    var entries = [];
    if (!payload) return entries;

    if (Array.isArray(payload.entries)) {
      payload.entries.forEach(function (entry) { addEntry(entries, entry); });
    }

    parseRaw(payload.all_conjugations_raw, entries);
    parseRaw(payload.all_conjugations_value_raw, entries);

    return dedupeEntries(entries);
  }

  function dedupeEntries(entries) {
    var seen = {};
    return entries.filter(function (entry) {
      var key = (entry && entry.url || '').toLowerCase();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function fetchProductByHandle(handle) {
    handle = normalizeSku(handle);
    if (!handle) return Promise.resolve(null);

    return fetchJson('/products/' + handle + '.js', 'product').then(function (product) {
      if (!product || !product.handle) return null;

      var sku = '';
      if (Array.isArray(product.variants) && product.variants.length && product.variants[0]) {
        sku = product.variants[0].sku || '';
      }

      return {
        title: product.title || handle,
        url: '/products/' + product.handle,
        handle: product.handle,
        sku: sku || handle
      };
    });
  }

  function fetchEntryForLabel(baseSku, label) {
    var handles = candidateHandlesForLabel(baseSku, label);

    function tryHandle(index) {
      if (index >= handles.length) return Promise.resolve(null);
      return fetchProductByHandle(handles[index]).then(function (entry) {
        if (!entry) return tryHandle(index + 1);
        entry.title = canonicalLabel(label) || entry.title;
        entry.sku = entry.sku || handles[index];
        entry.handle = entry.handle || handles[index];
        entry.url = entry.url || ('/products/' + handles[index]);
        return entry;
      });
    }

    return tryHandle(0);
  }

  function fetchDirectSiblingEntries(baseSku) {
    baseSku = stripKnownSuffix(baseSku);
    if (!isAntibodyBaseSku(baseSku)) return Promise.resolve([]);

    var requests = LABELS.filter(function (label) {
      return canonicalLabel(label) && canonicalLabel(label) !== 'Unconjugated';
    }).map(function (label) {
      return fetchEntryForLabel(baseSku, label);
    });

    var timeout = new Promise(function (resolve) {
      window.setTimeout(function () { resolve([]); }, 9000);
    });

    return Promise.race([
      Promise.all(requests).then(function (results) {
        return dedupeEntries(results.filter(Boolean));
      }).catch(function () { return []; }),
      timeout
    ]);
  }

  function endpointForHandle(handle) {
    return handle ? '/products/' + handle + '?view=conjugation-options&bioss_product_page_conj_v=64' : '';
  }

  function findPlaceholder() {
    return document.querySelector('[data-bioss-product-page-conj-placeholder]') ||
      document.querySelector('[data-bioss-product-page-conjugation-options]');
  }

  function currentProductUrl() {
    var placeholder = findPlaceholder();
    var url = placeholder ? normalizeUrl(placeholder.getAttribute('data-product-url') || '') : '';
    if (url) return url;

    var canonical = document.querySelector('link[rel="canonical"]');
    url = canonical ? normalizeUrl(canonical.getAttribute('href') || '') : '';
    if (url) return url;

    return normalizeUrl(window.location.pathname || '');
  }

  function currentHandle() {
    var placeholder = findPlaceholder();
    var handle = placeholder ? placeholder.getAttribute('data-product-handle') : '';
    if (handle) return handle;

    var canonical = document.querySelector('link[rel="canonical"]');
    handle = canonical ? handleFromUrl(canonical.getAttribute('href') || '') : '';
    if (handle) return handle;

    return handleFromUrl(window.location.pathname || '');
  }

  function currentSku() {
    var placeholder = findPlaceholder();
    var sku = placeholder ? placeholder.getAttribute('data-product-sku') : '';
    if (sku) return normalizeSku(sku);

    var skuText = document.body ? document.body.textContent.match(/\bBS[MFP]?-[0-9]{2,8}[A-Z]?(?:-[A-Z0-9.]+)?\b/i) : null;
    return skuText && skuText[0] ? normalizeSku(skuText[0]) : '';
  }

  function buildItems(payload, extraEntries, fallbackBaseSku) {
    payload = payload || {};

    var baseSku = normalizeSku(payload.base_sku || payload.source_sku || payload.sku || fallbackBaseSku || '');
    baseSku = stripKnownSuffix(baseSku);

    var baseUrl = normalizeUrl(payload.source_url || '');
    if (!baseUrl && baseSku) baseUrl = '/products/' + baseSku;

    var entries = entriesFromPayload(payload).concat(extraEntries || []);
    var pageUrl = currentProductUrl();
    var seen = {};
    var items = [];

    if (baseUrl && baseUrl !== pageUrl) {
      seen.unconjugated = true;
      items.push({ label: 'Unconjugated', url: baseUrl });
    }

    entries.forEach(function (entry) {
      var label = labelFromText([entry.title, entry.sku, entry.handle, entry.url].join(' '), baseSku);
      var url = normalizeUrl(entry.url);

      if (!label || label === 'Unconjugated' || !url || url === pageUrl) return;

      var key = label.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;

      items.push({ label: label, url: url });
    });

    return items;
  }

  function validateItem(item) {
    if (!item || !item.url) return Promise.resolve(null);
    var handle = handleFromUrl(item.url);
    if (!handle) return Promise.resolve(null);

    return fetchProductByHandle(handle).then(function (product) {
      if (!product || !product.url) return null;
      item.url = product.url;
      return item;
    });
  }

  function validateItems(items) {
    if (!items || !items.length) return Promise.resolve([]);

    return Promise.all(items.map(validateItem)).then(function (validated) {
      var seen = {};
      return validated.filter(function (item) {
        var key = item && item.label ? item.label.toLowerCase() : '';
        if (!item || !item.url || !key || seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }).catch(function () {
      return [];
    });
  }

  function makePill(label, url) {
    var a = document.createElement('a');
    a.className = 'bioss-product-page-conj-pill ' + pillClass(label);
    a.href = url;
    a.setAttribute('aria-label', 'View ' + label + ' product');
    a.textContent = label;
    return a;
  }

  function renderItems(placeholder, items) {
    if (!placeholder || !items || !items.length) {
      if (placeholder) placeholder.hidden = true;
      return false;
    }

    var pills = placeholder.querySelector('.bioss-product-page-conj-pills');
    if (!pills) return false;

    // Source removal: keep only heading + pills container.
    Array.prototype.slice.call(placeholder.children).forEach(function (child) {
      if (!child.classList) return;
      if (
        !child.classList.contains('bioss-product-page-conj-heading') &&
        !child.classList.contains('bioss-product-page-conj-pills')
      ) {
        child.parentNode.removeChild(child);
      }
    });

    pills.innerHTML = '';
    items.forEach(function (item) {
      pills.appendChild(makePill(item.label, item.url));
    });

    placeholder.hidden = false;
    placeholder.classList.remove('is-empty');
    placeholder.classList.add('is-ready');
    placeholder.setAttribute('data-bioss-product-page-conj-rendered', 'true');
    removeLegacyConjugationRows(placeholder);
    return true;
  }

  function removeLegacyConjugationRows(placeholder) {
    placeholder = placeholder || findPlaceholder();
    if (!placeholder) return;

    // Keep cleanup scoped to the product-page placeholder. Collection/search cards use
    // their own conjugation badge and dropdown elements and must never be removed here.
    Array.prototype.slice.call(placeholder.querySelectorAll('.bioss-product-page-conj-dot, .bioss-product-page-conj-dot + span')).forEach(function (el) {
      if (!el || !el.parentNode) return;
      el.parentNode.removeChild(el);
    });
  }

  function boot() {
    var placeholder = findPlaceholder();
    if (!placeholder) return;
    removeLegacyConjugationRows(placeholder);

    var handle = currentHandle();
    var sku = currentSku();
    var baseSku = stripKnownSuffix(sku);

    fetchJson(endpointForHandle(handle), 'endpoint').then(function (payload) {
      var endpointItems = buildItems(payload, [], baseSku);

      function renderFallback() {
        return fetchDirectSiblingEntries(baseSku).then(function (extraEntries) {
          var items = buildItems(payload || {
            base_sku: baseSku,
            source_sku: baseSku,
            source_url: '/products/' + baseSku
          }, extraEntries, baseSku);

          return validateItems(items).then(function (validItems) {
            renderItems(placeholder, validItems);
          });
        });
      }

      if (endpointItems.length) {
        return validateItems(endpointItems).then(function (validItems) {
          if (validItems.length) {
            renderItems(placeholder, validItems);
            return;
          }
          return renderFallback();
        });
      }

      return renderFallback();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    window.setTimeout(boot, 250);
    window.setTimeout(boot, 1000);
    window.setTimeout(removeLegacyConjugationRows, 1600);
    window.setTimeout(removeLegacyConjugationRows, 3000);
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.bioss-product-page-conj-pill')) {
      window.setTimeout(removeLegacyConjugationRows, 100);
      window.setTimeout(removeLegacyConjugationRows, 600);
    }
  }, true);
})();
